module.exports = __webpack_public_path__ + "static/img/imagen1.8a73ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgabout/imagen1.jpg
// module id = ArgQ
// module chunks = 1